import React from 'react';
import NetworkCalls from '../utils/NetworkCalls';
import LevelStyles from '../sass/partials/_levelSlider.module.scss';
import classNames from 'classnames';
import Dotenv from '../utils/Dotenv';

interface SurveyDate {
    surveyName: string;
    date: Date;
}

interface SurveyMonth {
    monthName: string;
    dates: SurveyDate[];
}

interface Props {
    timelineOpen: boolean;
    floor: number;
    changeFloor: Function;
    date: Date;
}

interface State {
    floors: number[];
    surveys: SurveyMonth[];
}

export default class LevelSlider extends React.Component<Props, State> {
    public state: State = {
        floors: [],
        surveys: [],
    };

    private abortController = new AbortController();

    private getFloorsJSX(floors: number[], noFloors: number[]):
        React.ReactElement[] {
        const radioList = noFloors.map((floor) => {
            return (floors.indexOf(floor) > -1) ?
                (<label className={classNames(LevelStyles.floorGroup, floor > 9
                    ? LevelStyles.doubleDigit : '')} key={floor} >
                    <input
                        type="radio"
                        name="floorGroup"
                        className={LevelStyles.select}
                        key={floor}
                        value={floor}
                        onChange={(e): void =>
                            this.props.changeFloor(e.target.value)}
                        checked={floor === Number(this.props.floor)}
                    />
                    <span>{floor}</span>
                </label>) :
                (<label className={classNames(LevelStyles.disabledFloorGroup,
                    floor > 9 ? LevelStyles.doubleDigit : '')} key={floor} >
                    <input
                        type="radio"
                        name="floorGroup"
                        className={LevelStyles.select}
                        key={floor}
                        value={floor}
                        onChange={(e): void =>
                            this.props.changeFloor(e.target.value)}
                        disabled
                    />
                    <span>{floor}</span>
                </label>)

        });

        return radioList;
    }

    private updateFloors(): void {
        fetch(Dotenv.BASE_URL + '/api/survey/details/compact/?date=' +
            this.props.date.toISOString(), {
            signal: this.abortController.signal,
        })
            .then(res => res.json())
            .then(
                res => {
                    if (res.success === true) {
                        this.setState({
                            floors:
                                [...new Set<number>(
                                    res.payload.map((e: any) => e.floor
                                    ))].reverse()
                        });
                    }
                },
                (): void => {
                    console.log('No survey for the given date & floor found');
                },
            );
    }

    private switchLevels(): void {
        document.addEventListener('keydown', (e) => {
            let index = 0;
            this.setState({floors: this.state.floors.sort((a: number, b: number) => {return b - a})})
            for (let i = 0; i <= this.state.floors.length; i++) {
                if (this.state.floors[i] === Number(this.props.floor)) {
                    index = i;
                }
            }
            //Monitor event
            if (e.code === 'ArrowUp') {
                const tempIndex = this.state.floors[index - 1];
                
                if (tempIndex !== undefined) {
                    this.props.changeFloor(tempIndex);
                }
            } else if (e.code === 'ArrowDown') {
                const tempIndex = this.state.floors[index + 1];
                if (tempIndex !== undefined) {
                    this.props.changeFloor(tempIndex);
                }
            }
        });
    }

    public componentDidMount(): void {
        NetworkCalls.fetchSurveys(this.abortController, this.props.floor)
            .then(res => {
                this.setState({ surveys: res });
                this.updateFloors();
            });
            this.switchLevels();
    }

    public componentDidUpdate(prevProps: Props): void {
        if (prevProps.date !== this.props.date) {
            NetworkCalls.fetchSurveys(this.abortController, this.props.floor)
                .then(res => {
                    this.setState({ surveys: res });
                    this.updateFloors();
                });
        }
    }

    public componentWillUnmount(): void {
        this.abortController.abort();
    }

    private createFloorArray(floors: number): number[] {
        const floorArray = [];
        for (var i = 1; i <= floors; i++) {
            floorArray.push(i);
        }
        return floorArray.reverse();
    }

    public render(): React.ReactElement {
        return (
            <div className={classNames(LevelStyles.levelsSelect,
                this.props.timelineOpen ? LevelStyles.showMargin : '')}>
                {this.getFloorsJSX(this.state.floors,
                    this.createFloorArray(Dotenv.FLOORS))}
            </div >
        );
    }
}
